import React, { useState, useRef } from 'react';
import File from '../Files/Files';
import PropertiesService from '../../../Services/PropertiesService';
import loader from '../../../assets/Images/Request_Property/Loader.gif';


import "./Category.css";

const Category = ({ category, description, files, onDeleteFile, onEditFile, onAddFile }) => {
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);


    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('image', file);
        setIsLoading(true);
        try {
            const response = await PropertiesService.UploadFiles(formData)
            const data = response.Location;
            const array = {
                id: Math.random().toString(36).substr(2, 9),
                name: file.name,
                type: file.type,
                size: file.size,
                file: data,
            };
            onAddFile(category, array);
        } catch (error) {
            console.error('Error uploading file:', error);
            alert('There was an error uploading the file.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="category-container">
            <div className="row">
{/*             
                <div className="col-md-2">
                    <div className="fab-button">
                        {isLoading ? <img src={loader} style={{ width: '40px' }} /> : (
                            <FaPlus onClick={triggerFileInput} disabled={isLoading} size={20} />
                        )}
                    </div>
                </div> */}
            </div>
            <div className={files?.length === 1 ? "row justify-content-center" : "row justify-content-start"}>
                {
                    files?.map(file => (
                        <>
                            <div className="col-md-4">
                                <div className="border rounded-4 p-3 bg-white shadow-sm h-100">
                             
                           <ul className="list-unstyled text-muted small mb-2 p-3">
                                    <li className="deptlst">
                                        <i className="fas fa-file-alt me-2 text-dark" />
                                        <strong>Type:</strong>{" "}
                                        {file.fields?.typeofdocument || "N/A"}
                                    </li>
                                    <li className="deptlst">
                                        <i className="fas fa-calendar-alt me-2 text-dark" />
                                        <strong>Date:</strong>{" "}
                                        {file.fields?.datethedocumentwasissued
                                            ? file.fields.datethedocumentwasissued
                                                .split("-")
                                                .reverse()
                                                .join("-")
                                            : "N/A"}
                                    </li>
                                    <li className="deptlst">
                                        <i className="fas fa-user-tie me-2 text-dark" />
                                        <strong>Issued By Officer Name:</strong>{" "}
                                        {file.fields?.nameofissuingofficer || "N/A"}
                                    </li>
                                    <li className="deptlst">
                                        <i className="fas fa-id-badge me-2 text-dark" />
                                        <strong>Officer Designation:</strong>{" "}
                                        {file.fields?.designationofofficer || "N/A"}
                                    </li>
                                    <li className="deptlst">
                                        <i className="fas fa-map-marker-alt me-2 text-dark" />
                                        <strong>Office:</strong>{" "}
                                        {file.fields?.officesituatedat || "N/A"}
                                    </li>
                                    <li className="deptlst">
                                        <i className="fas fa-building me-2 text-dark" />
                                        <strong>Related Dept:</strong>{" "}
                                        {file.fields?.departmentofregistrationandstamps || "N/A"}
                                    </li>
                                </ul>
                                    {file.loading === true ?    <div className="loader-container">
                                    <img src={loader} alt="Loading..." />
                                    <p>Uploading...</p>
                                  </div> :
                                        <File file={file} onDeleteFile={onDeleteFile} onEditFile={onEditFile} category={category} />}
                                </div>
                            </div>
                        </>
                    ))
                }

            </div>
            <div className="add-file-container">
                <input
                    ref={fileInputRef}
                    type="file"
                    onChange={handleFileChange}
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                    style={{ display: 'none' }}

                    disabled={isLoading}
                />
            </div>
        </div>
    );
};

export default Category;

